import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import actions from './actions';

export function* getProductGroups() {
    yield takeEvery(actions.FETCH_PRODUCT_GROUPS_REQUESTED, function* (action) {
        try {
          const productGroups = yield call(actions.getProductGroups, action.payload);
          yield put({ type: actions.FETCH_PRODUCT_GROUPS_SUCCEEDED, productGroups });
        } catch (error) {
          yield put({ type: actions.FETCH_PRODUCT_GROUPS_FAILED, error: error.message });
        }
    });
}

export function* getProductGroup() {
    yield takeEvery(actions.FETCH_PRODUCT_GROUP_REQUESTED, function* (action) {
        try {
            const productGroup = yield call(actions.getProductGroup, action.payload);
            yield put({ type: actions.FETCH_PRODUCT_GROUP_SUCCEEDED, productGroup: productGroup.items_group_info });
        } catch (error) {
            yield put({ type: actions.FETCH_PRODUCT_GROUP_FAILED, error: error.message });
        }
    });
}

export function* deleteProductGroup() {
  yield takeEvery(actions.DELETE_PRODUCT_GROUP_REQUESTED, function* (action) {
      try {
          const productGroup = yield call(actions.deleteProductGroup, action.payload);
          yield put({ type: actions.DELETE_PRODUCT_GROUP_SUCCEEDED, productGroupDeleted: productGroup });
      } catch (error) {
          yield put({ type: actions.DELETE_PRODUCT_GROUP_FAILED, error: error.message });
      }
  });
}


export default function* rootSaga() {
  yield all([
    fork(getProductGroups),
    fork(getProductGroup),
    fork(deleteProductGroup)
  ]);
}
